export default "__VITE_ASSET__UrszgX2R__"